<template>

  <transition name="fade">
    <div class="sidebar-backdrop z-40" @click="toggle" v-if="open"></div>
  </transition>

  <button @click="toggle"
          class="nav-toggle"
          :aria-expanded="open"
          aria-label="Mobile Navigation Button"
          :aria-controls="controls"
  >
    <span class="sr-only">Toggle Navigation</span>

    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
         class="fill-current stroke-current h-6 w-6">
      <title>Toggle Navigation Button</title>
      <g>
        <path d="M30,15H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,15,30,15z"></path>
        <path d="M30,6H2C1.4,6,1,6.4,1,7s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,6,30,6z"></path>
        <path d="M30,24H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,24,30,24z"></path
        >
      </g>

    </svg>
  </button>

  <div :class="open ? '-translate-x-full': 'translate-x-0'"
       class="bg-white dark:bg-black min-h-screen w-2/3 p-6 lg:p-0 md:w-1/3 z-40 fixed overflow-y-auto md:overflow-y-visible left-full top-0 transform transition-transform ease-in-out duration-300 lg:min-h-0 lg:static lg:w-full lg:flex lg:w-auto lg:transform-none lg:transition-none lg:bg-transparent z-50 shadow-page dark:shadow-[#111]/20 lg:shadow-none lg:dark:shadow-none">

    <button @click="toggle"
            class="nav-toggle nav-toggle--close"
            :aria-expanded="open"
            aria-label="Mobile Navigation Button"
            :aria-controls="controls"
    >

      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
           class="fill-current stroke-current h-6 w-6">
        <title>Toggle Navigation Button</title>
        <g stroke-linecap="round" stroke-linejoin="round" stroke-width="2" fill="none">
          <line x1="27" y1="5" x2="5" y2="27"></line>
          <line x1="27" y1="27" x2="5" y2="5"></line>
        </g>
      </svg>
    </button>
    <div v-cloak>
      <slot></slot>
    </div>

  </div>

</template>

<script>

import {onMounted, ref} from 'vue';

export default {
  name: "Navigation",
  props: {
    controls: {
      type: String
    }
  },
  setup() {
    const open = ref(false);

    const toggle = () => {
      open.value = !open.value
    }

    return {
      open,
      toggle
    }
  },

};
</script>

<style lang="postcss">


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.sidebar-backdrop {
  @apply lg:hidden bg-white/75 dark:bg-black/75;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
}
</style>

